const __script_base__ = {
  name: 'TextInput',
  props: {
    id: {
      type: String,
      default: ''
    },
    value: {
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    } // label?, value
  },
  computed: {
    bindProps() {
      return {
        id: this.id,
        readonly: this.readonly,
        required: !!this.required,
        placeholder: this.placeholder
      };
    },
    // 当前值，使用 JSON 表示
    valueJSON() {
      return JSON.stringify(this.value);
    },
    enums() {
      return this.options.map(x => ({
        label: x.label || String(x.value),
        valueJSON: JSON.stringify(x.value)
      }));
    }
  },
  methods: {
    handleChange(ev) {
      this.$emit('change', JSON.parse(ev.target.value));
    },
    validate() {
      if (this.readonly) return; // 只读模式不需要校验

      const {
        value
      } = this;
      if (!value && this.required) throw new Error('此字段必填');
      // 话说，要不要校验选项是否存在于 enum
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("select", _vm._b({
    staticClass: "uc-inputbox",
    class: {
      hasError: _vm.hasError
    },
    domProps: {
      value: _vm.valueJSON
    },
    on: {
      input: _vm.handleChange
    }
  }, "select", _vm.bindProps, false), [!_vm.enums.some(function (it) {
    return it.valueJSON === _vm.valueJSON;
  }) ? _c("option", {
    key: "__bad_item__",
    staticStyle: {
      display: "none"
    },
    domProps: {
      value: _vm.valueJSON
    }
  }, [_vm._v("\n    " + _vm._s(_vm.valueJSON) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm._l(_vm.enums, function (it, idx) {
    return _c("option", {
      key: idx,
      domProps: {
        value: it.valueJSON
      }
    }, [_vm._v("\n    " + _vm._s(it.label) + "\n  ")]);
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/Select/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);